const dataTableLanguageUrl = "/js/datatables/sv_SE.json";

export function initializeBillingRowsTable() {
    const billingRowsTable = $("#billing-rows-table").DataTable({
        language: {url: dataTableLanguageUrl},
        processing: true,
        serverSide: false,
        responsive: true,
        stateSave: true,
        stateSaveParams: saveBillingRowsTableState,
        stateLoadParams: loadBillingRowsTableState,
        scrollX: true,
        pageLength: 50,
        initComplete: function () {
            const filterValue = this.api().state.loaded() ? this.api().state.loaded().filterValue : 'active';
            $(`input[type=radio][name=active-filter][value=${filterValue}]`).prop('checked', true);
            applyActiveFilter(filterValue);
        },
        layout: {
            topStart: [
                'pageLength',
                { buttons: ['excel'] }
            ],
        }
    });

    $("input[type=radio][name=active-filter]").on("change", function () {
        const filterValue = $(this).val();
        applyActiveFilter(filterValue);
        billingRowsTable.state.save();
    });
}

function saveBillingRowsTableState(settings, data) {
    data.filterValue = $("input[type=radio][name=active-filter]:checked").val();
}

function loadBillingRowsTableState(settings, data) {
    if (!data.filterValue) {
        data.filterValue = 'active';
    }
}

function applyActiveFilter(value) {
    const billingRowsTable = $("#billing-rows-table").DataTable();

    switch (value) {
        case "all":
            billingRowsTable.column(6).search("").draw();
            break;
        case "active":
            billingRowsTable.column(6).search("^\\s*-\\s*$", true, false).draw();
            break;
        case "inactive":
            billingRowsTable.column(6).search("^(?!\\s*-\\s*$).+", true, false).draw();
            break;
    }
}
